import Layout from "../components/Layout";
import about_wide_1 from "../../assets/niceshop/img/about/about-wide-1.webp";
import person_f_7 from "../../assets/niceshop/img/person/person-f-7.webp";
import OrdersContextProvider, {useOrdersContext} from "../context/OrdersContext";
import { useState } from "react";
import { useLoginContext } from "../context/LoginContext";
import { useCartContext } from "../context/CartContext";
import { getRootUrl } from "../../consts";
import { Link } from "react-router-dom";

function PersonalInfo(){
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  return <div className="settings-section" data-aos="fade-up">
    <h3>Personal Information</h3>
    <form className="php-email-form settings-form">
      <div className="row g-3">
        <div className="col-md-6">
          <label htmlFor="firstName" className="form-label">First Name</label>
          <input type="text" className="form-control" id="firstName" value={firstName} required="" 
            onChange={evt=>{setFirstName(evt.target.value)}}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="lastName" className="form-label">Last Name</label>
          <input type="text" className="form-control" id="lastName" value={lastName} required="" 
            onChange={evt=>{setLastName(evt.target.value)}}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" className="form-control" id="email" value={email} required="" 
            onChange={evt=>{setEmail(evt.target.value)}}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="phone" className="form-label">Phone</label>
          <input type="tel" className="form-control" id="phone" value={telephone} 
            onChange={evt=>{setTelephone(evt.target.value)}}
          />
        </div>
      </div>

      <div className="form-buttons">
        <button type="submit" className="btn-save">Save Changes</button>
      </div>

      <div className="loading">Loading</div>
      <div className="error-message"></div>
      <div className="sent-message">Your changes have been saved successfully!</div>
    </form>
  </div>;

}

function OrdersInfo(){
  const {orders} = useOrdersContext();
  const rootUrl = getRootUrl();
  return <>
    <div className="section-header" data-aos="fade-up">
      <h2>Orders</h2>
      <div className="header-actions">

        <div className="search-box">
          <i className="bi bi-search"></i>
          <input type="text" placeholder="Search orders..." />
        </div>

        <div className="dropdown">
          <button className="filter-btn" data-bs-toggle="dropdown">
            <i className="bi bi-funnel"></i>
            <span>Filter</span>
          </button>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="#">All Orders</a></li>
            <li><a className="dropdown-item" href="#">Processing</a></li>
            <li><a className="dropdown-item" href="#">Shipped</a></li>
            <li><a className="dropdown-item" href="#">Delivered</a></li>
            <li><a className="dropdown-item" href="#">Cancelled</a></li>
          </ul>
        </div>

      </div>
    </div>

    <div className="orders-grid">
      {(orders||[]).length>0?(orders||[]).map((order, orderIdx)=><div
        key={order.__id}
        className="order-card"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <div className="order-header">
          <div className="order-id">
            <span className="label">Order ID:</span>
            <span className="value">#{order.sn}</span>
          </div>
          <div className="order-date">{order.date}</div>
        </div>
        <div className="order-content">
          <div className="product-grid">
            <img src="assets/img/product/product-1.webp" alt="Product" loading="lazy" />
            <img src="assets/img/product/product-2.webp" alt="Product" loading="lazy" />
            <img src="assets/img/product/product-3.webp" alt="Product" loading="lazy" />
          </div>
          <div className="order-info">
            <div className="info-row">
              <span>Status</span>
              <span className="status processing">Processing</span>
            </div>
            <div className="info-row">
              <span>Items</span>
              <span>3 items</span>
            </div>
            <div className="info-row">
              <span>Total</span>
              <span className="price">$789.99</span>
            </div>
          </div>
        </div>
        <div className="order-footer">
          <button type="button" className="btn-track" data-bs-toggle="collapse" data-bs-target="#tracking1" aria-expanded="false">Track Order</button>
          <button type="button"
            className="btn-details"
            data-bs-toggle="collapse"
            data-bs-target={`#details${orderIdx}`}
            aria-expanded="false"
          >View Details</button>
        </div>

        
        <div className="collapse tracking-info" id="tracking1">
          <div className="tracking-timeline">
            <div className="timeline-item completed">
              <div className="timeline-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <div className="timeline-content">
                <h5>Order Confirmed</h5>
                <p>Your order has been received and confirmed</p>
                <span className="timeline-date">Feb 20, 2025 - 10:30 AM</span>
              </div>
            </div>

            <div className="timeline-item completed">
              <div className="timeline-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <div className="timeline-content">
                <h5>Processing</h5>
                <p>Your order is being prepared for shipment</p>
                <span className="timeline-date">Feb 20, 2025 - 2:45 PM</span>
              </div>
            </div>

            <div className="timeline-item active">
              <div className="timeline-icon">
                <i className="bi bi-box-seam"></i>
              </div>
              <div className="timeline-content">
                <h5>Packaging</h5>
                <p>Your items are being packaged for shipping</p>
                <span className="timeline-date">Feb 20, 2025 - 4:15 PM</span>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <i className="bi bi-truck"></i>
              </div>
              <div className="timeline-content">
                <h5>In Transit</h5>
                <p>Expected to ship within 24 hours</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <i className="bi bi-house-door"></i>
              </div>
              <div className="timeline-content">
                <h5>Delivery</h5>
                <p>Estimated delivery: Feb 22, 2025</p>
              </div>
            </div>
          </div>
        </div>

        
        <div className="collapse order-details" id={`details${orderIdx}`}>
          <div className="details-content">
            <div className="detail-section">
              <h5>Order Information</h5>
              <div className="info-grid">
                <div className="info-item">
                  <span className="label">Payment Method</span>
                  <span className="value">Credit Card (**** 4589)</span>
                </div>
                <div className="info-item">
                  <span className="label">Shipping Method</span>
                  <span className="value">Express Delivery (2-3 days)</span>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <h5>Items (3)</h5>
              <div className="order-items">
                <div className="item">
                  <img src="assets/img/product/product-1.webp" alt="Product" loading="lazy" />
                  <div className="item-info">
                    <h6>Lorem ipsum dolor sit amet</h6>
                    <div className="item-meta">
                      <span className="sku">SKU: PRD-001</span>
                      <span className="qty">Qty: 1</span>
                    </div>
                  </div>
                  <div className="item-price">$899.99</div>
                </div>

                <div className="item">
                  <img src="assets/img/product/product-2.webp" alt="Product" loading="lazy" />
                  <div className="item-info">
                    <h6>Consectetur adipiscing elit</h6>
                    <div className="item-meta">
                      <span className="sku">SKU: PRD-002</span>
                      <span className="qty">Qty: 2</span>
                    </div>
                  </div>
                  <div className="item-price">$599.95</div>
                </div>

                <div className="item">
                  <img src="assets/img/product/product-3.webp" alt="Product" loading="lazy" />
                  <div className="item-info">
                    <h6>Sed do eiusmod tempor</h6>
                    <div className="item-meta">
                      <span className="sku">SKU: PRD-003</span>
                      <span className="qty">Qty: 1</span>
                    </div>
                  </div>
                  <div className="item-price">$129.99</div>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <h5>Price Details</h5>
              <div className="price-breakdown">
                <div className="price-row">
                  <span>Subtotal</span>
                  <span>$1,929.93</span>
                </div>
                <div className="price-row">
                  <span>Shipping</span>
                  <span>$15.99</span>
                </div>
                <div className="price-row">
                  <span>Tax</span>
                  <span>$159.98</span>
                </div>
                <div className="price-row total">
                  <span>Total</span>
                  <span>$2,105.90</span>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <h5>Shipping Address</h5>
              <div className="address-info">
                <p>{ order.shipping_Address_attn }<br />123 Main Street<br />Apt 4B<br />New York, NY 10001<br />United States</p>
                <p className="contact">+1 (555) 123-4567</p>
              </div>
            </div>
          </div>
        </div>
      </div>):<p className="continue-shopping">
        
        <Link
          className="btn btn-link w-100"
          to={`${rootUrl}/wwapp/category`}
        >No order yet.  Go Shopping <i className="bi bi-arrow-right"></i></Link>
      </p>}

    </div>

      {/* <!-- Pagination --> */}
    {((orders||[]).length>0)&&<div className="pagination-wrapper" data-aos="fade-up">
      <button type="button" className="btn-prev" disabled="">
        <i className="bi bi-chevron-left"></i>
      </button>
      <div className="page-numbers">
        <button type="button" className="active">1</button>
        <button type="button">2</button>
        <button type="button">3</button>
        <span>...</span>
        <button type="button">12</button>
      </div>
      <button type="button" className="btn-next">
        <i className="bi bi-chevron-right"></i>
      </button>
    </div>}
  </>
}

// {/* <!-- Wishlist Tab --> */}
function WishListInfo(){
  const {wishList} = useCartContext();
  return <div className="tab-pane fade" id="wishlist">
      <div className="section-header" data-aos="fade-up">
        <h2>My Wishlist</h2>
        <div className="header-actions">
          <button type="button" className="btn-add-all">Add All to Cart</button>
        </div>
      </div>

      <div className="wishlist-grid">
        {wishList.map(wishItem=><div
          key={wishItem.__id}
          className="wishlist-card" data-aos="fade-up" data-aos-delay="100">
          <div className="wishlist-image">
            <img src="assets/img/product/product-1.webp" alt="Product" loading="lazy" />
            <button className="btn-remove" type="button" aria-label="Remove from wishlist">
              <i className="bi bi-trash"></i>
            </button>
            <div className="sale-badge">-20%</div>
          </div>
          <div className="wishlist-content">
            <h4>Lorem ipsum dolor sit amet</h4>
            <div className="product-meta">
              <div className="rating">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
                <span>(4.5)</span>
              </div>
              <div className="price">
                <span className="current">$79.99</span>
                <span className="original">$99.99</span>
              </div>
            </div>
            <button type="button" className="btn-add-cart">Add to Cart</button>
          </div>
        </div>)}
      </div>
    </div>;
}

function AccountContent(){
  const {orders} = useOrdersContext();
  const {userInfo:wwAppUserInfo} = useLoginContext();
  const {wishList} = useCartContext();
  return <main className="main">
    {/* <div>{JSON.stringify(orders)}</div> */}
    {/* <!-- Page Title --> */}
    <div className="page-title light-background">
      <div className="container d-lg-flex justify-content-between align-items-center">
        <h1 className="mb-2 mb-lg-0">Account</h1>
        <nav className="breadcrumbs">
          <ol>
            <li><a href="index.html">Home</a></li>
            <li className="current">Account</li>
          </ol>
        </nav>
      </div>
    </div>
    {/* <!-- End Page Title --> */}

    {/* <!-- Account Section --> */}
    <section id="account" className="account section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        {/* <!-- Mobile Menu Toggle --> */}
        <div className="mobile-menu d-lg-none mb-4">
          <button className="mobile-menu-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#profileMenu">
            <i className="bi bi-grid"></i>
            <span>Menu</span>
          </button>
        </div>

        <div className="row g-4">
          {/* <!-- Profile Menu --> */}
          <div className="col-lg-3">
            <div className="profile-menu collapse d-lg-block" id="profileMenu">
              {/* <!-- User Info --> */}
              <div className="user-info" data-aos="fade-right">
                <div className="user-avatar">
                  <img src="assets/img/person/person-f-1.webp" alt="Profile" loading="lazy" />
                  <span className="status-badge"><i className="bi bi-shield-check"></i></span>
                </div>
                <h4> {wwAppUserInfo.name} </h4>
                <div className="user-status">
                  <i className="bi bi-award"></i>
                  <span>Premium Member</span>
                </div>
              </div>

              {/* <!-- Navigation Menu --> */}
              <nav className="menu-nav">
                <ul className="nav flex-column" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" data-bs-toggle="tab" href="#orders">
                      <i className="bi bi-box-seam"></i>
                      <span>Orders</span>
                      <span className="badge">{(orders||[]).length}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#wishlist">
                      <i className="bi bi-heart"></i>
                      <span>Wishlist</span>
                      <span className="badge">{wishList.length}</span>
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#wallet">
                      <i className="bi bi-wallet2"></i>
                      <span>Payment Methods</span>
                    </a>
                  </li> */}
                  {/* <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#reviews">
                      <i className="bi bi-star"></i>
                      <span>My Reviews</span>
                    </a>
                  </li> */}
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#addresses">
                      <i className="bi bi-geo-alt"></i>
                      <span>Addresses</span>
                    </a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#settings">
                      <i className="bi bi-gear"></i>
                      <span>Account Settings</span>
                    </a>
                  </li>

                {(wwAppUserInfo.userType=='clientGroup')&&<li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#settings">
                      <i className="bi bi-diagram-3"></i>
                      <span>Subsidaries</span>
                    </a>
                  </li>
                }

                
                </ul>

                <div className="menu-footer">
                  <a href="#" className="help-link">
                    <i className="bi bi-question-circle"></i>
                    <span>Help Center</span>
                  </a>
                  <a href="#" className="logout-link">
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Log Out</span>
                  </a>
                </div>
              </nav>
            </div>
          </div>

          {/* <!-- Content Area --> */}
          <div className="col-lg-9">
            <div className="content-area">

              <div className="tab-content">


                {/* <!-- Orders Tab --> */}
                <div className="tab-pane fade show active" id="orders">

                    <OrdersInfo></OrdersInfo>


                </div>

                <WishListInfo></WishListInfo>

                {/* <!-- Payment Methods Tab --> */}
                {/* <div className="tab-pane fade" id="wallet">
                  <div className="section-header" data-aos="fade-up">
                    <h2>Payment Methods</h2>
                    <div className="header-actions">
                      <button type="button" className="btn-add-new">
                        <i className="bi bi-plus-lg"></i>
                        Add New Card
                      </button>
                    </div>
                  </div>

                  <div className="payment-cards-grid">
                    <!-- Payment Card 1 -->
                    <div className="payment-card default" data-aos="fade-up" data-aos-delay="100">
                      <div className="card-header">
                        <i className="bi bi-credit-card"></i>
                        <div className="card-badges">
                          <span className="default-badge">Default</span>
                          <span className="card-type">Visa</span>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card-number">•••• •••• •••• 4589</div>
                        <div className="card-info">
                          <span>Expires 09/2026</span>
                        </div>
                      </div>
                      <div className="card-actions">
                        <button type="button" className="btn-edit">
                          <i className="bi bi-pencil"></i>
                          Edit
                        </button>
                        <button type="button" className="btn-remove">
                          <i className="bi bi-trash"></i>
                          Remove
                        </button>
                      </div>
                    </div>

                    <!-- Payment Card 2 -->
                    <div className="payment-card" data-aos="fade-up" data-aos-delay="200">
                      <div className="card-header">
                        <i className="bi bi-credit-card"></i>
                        <div className="card-badges">
                          <span className="card-type">Mastercard</span>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card-number">•••• •••• •••• 7821</div>
                        <div className="card-info">
                          <span>Expires 05/2025</span>
                        </div>
                      </div>
                      <div className="card-actions">
                        <button type="button" className="btn-edit">
                          <i className="bi bi-pencil"></i>
                          Edit
                        </button>
                        <button type="button" className="btn-remove">
                          <i className="bi bi-trash"></i>
                          Remove
                        </button>
                        <button type="button" className="btn-make-default">Make Default</button>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <!-- Reviews Tab --> */}
                {/* <div className="tab-pane fade" id="reviews">

                  <div className="section-header" data-aos="fade-up">
                    <h2>My Reviews</h2>
                    <div className="header-actions">
                      <div className="dropdown">
                        <button className="filter-btn" data-bs-toggle="dropdown">
                          <i className="bi bi-funnel"></i>
                          <span>Sort by: Recent</span>
                        </button>
                        <ul className="dropdown-menu">
                          <li><a className="dropdown-item" href="#">Recent</a></li>
                          <li><a className="dropdown-item" href="#">Highest Rating</a></li>
                          <li><a className="dropdown-item" href="#">Lowest Rating</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="reviews-grid">
                    <!-- Review Card 1 -->
                    <div className="review-card" data-aos="fade-up" data-aos-delay="100">
                      <div className="review-header">
                        <img src="assets/img/product/product-1.webp" alt="Product" className="product-image" loading="lazy" />
                        <div className="review-meta">
                          <h4>Lorem ipsum dolor sit amet</h4>
                          <div className="rating">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <span>(5.0)</span>
                          </div>
                          <div className="review-date">Reviewed on Feb 15, 2025</div>
                        </div>
                      </div>
                      <div className="review-content">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                      </div>
                      <div className="review-footer">
                        <button type="button" className="btn-edit">Edit Review</button>
                        <button type="button" className="btn-delete">Delete</button>
                      </div>
                    </div>

                    <!-- Review Card 2 -->
                    <div className="review-card" data-aos="fade-up" data-aos-delay="200">
                      <div className="review-header">
                        <img src="assets/img/product/product-2.webp" alt="Product" className="product-image" loading="lazy" />
                        <div className="review-meta">
                          <h4>Consectetur adipiscing elit</h4>
                          <div className="rating">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star"></i>
                            <span>(4.0)</span>
                          </div>
                          <div className="review-date">Reviewed on Feb 10, 2025</div>
                        </div>
                      </div>
                      <div className="review-content">
                        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                      </div>
                      <div className="review-footer">
                        <button type="button" className="btn-edit">Edit Review</button>
                        <button type="button" className="btn-delete">Delete</button>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <!-- Addresses Tab --> */}
                <div className="tab-pane fade" id="addresses">
                  <div className="section-header" data-aos="fade-up">
                    <h2>My Addresses</h2>
                    <div className="header-actions">
                      <button type="button" className="btn-add-new">
                        <i className="bi bi-plus-lg"></i>
                        Add New Address
                      </button>
                    </div>
                  </div>

                  <div className="addresses-grid">
                    {/* <!-- Address Card 1 --> */}
                    <div className="address-card default" data-aos="fade-up" data-aos-delay="100">
                      <div className="card-header">
                        <h4>Home</h4>
                        <span className="default-badge">Default</span>
                      </div>
                      <div className="card-body">
                        <p className="address-text">123 Main Street<br />Apt 4B<br />New York, NY 10001<br />United States</p>
                        <div className="contact-info">
                          <div><i className="bi bi-person"></i> {wwAppUserInfo.name} </div>
                          <div><i className="bi bi-telephone"></i> {wwAppUserInfo.telephone} </div>
                        </div>
                      </div>
                      <div className="card-actions">
                        <button type="button" className="btn-edit">
                          <i className="bi bi-pencil"></i>
                          Edit
                        </button>
                        <button type="button" className="btn-remove">
                          <i className="bi bi-trash"></i>
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* <!-- Address Card 2 --> */}
                    <div className="address-card" data-aos="fade-up" data-aos-delay="200">
                      <div className="card-header">
                        <h4>Office</h4>
                      </div>
                      <div className="card-body">
                        <p className="address-text">456 Business Ave<br />Suite 200<br />San Francisco, CA 94107<br />United States</p>
                        <div className="contact-info">
                          <div><i className="bi bi-person"></i> {wwAppUserInfo.name} </div>
                          <div><i className="bi bi-telephone"></i> {wwAppUserInfo.telephone} </div>
                        </div>
                      </div>
                      <div className="card-actions">
                        <button type="button" className="btn-edit">
                          <i className="bi bi-pencil"></i>
                          Edit
                        </button>
                        <button type="button" className="btn-remove">
                          <i className="bi bi-trash"></i>
                          Remove
                        </button>
                        <button type="button" className="btn-make-default">Make Default</button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!-- Settings Tab --> */}
                <div className="tab-pane fade" id="settings">
                  <div className="section-header" data-aos="fade-up">
                    <h2>Account Settings</h2>
                  </div>

                  <div className="settings-content">
                    {/* <!-- Personal Information --> */}
                    <PersonalInfo></PersonalInfo>

                    {/* <!-- Email Preferences --> */}
                    <div className="settings-section" data-aos="fade-up" data-aos-delay="100">
                      <h3>Email Preferences</h3>
                      <div className="preferences-list">
                        <div className="preference-item">
                          <div className="preference-info">
                            <h4>Order Updates</h4>
                            <p>Receive notifications about your order status</p>
                          </div>
                          <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" id="orderUpdates" defaultChecked="" />
                          </div>
                        </div>

                        <div className="preference-item">
                          <div className="preference-info">
                            <h4>Promotions</h4>
                            <p>Receive emails about new promotions and deals</p>
                          </div>
                          <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" id="promotions" />
                          </div>
                        </div>

                        <div className="preference-item">
                          <div className="preference-info">
                            <h4>Newsletter</h4>
                            <p>Subscribe to our weekly newsletter</p>
                          </div>
                          <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" id="newsletter" defaultChecked="" />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <!-- Security Settings --> */}
                    <div className="settings-section" data-aos="fade-up" data-aos-delay="200">
                      <h3>Security</h3>
                      <form className="php-email-form settings-form">
                        <div className="row g-3">
                          <div className="col-md-12">
                            <label htmlFor="currentPassword" className="form-label">Current Password</label>
                            <input type="password" className="form-control" id="currentPassword" required="" />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="newPassword" className="form-label">New Password</label>
                            <input type="password" className="form-control" id="newPassword" required="" />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                            <input type="password" className="form-control" id="confirmPassword" required="" />
                          </div>
                        </div>

                        <div className="form-buttons">
                          <button type="submit" className="btn-save">Update Password</button>
                        </div>

                        <div className="loading">Loading</div>
                        <div className="error-message"></div>
                        <div className="sent-message">Your password has been updated successfully!</div>
                      </form>
                    </div>

                    {/* <!-- Delete Account --> */}
                    <div className="settings-section danger-zone" data-aos="fade-up" data-aos-delay="300">
                      <h3>Delete Account</h3>
                      <div className="danger-zone-content">
                        <p>Once you delete your account, there is no going back. Please be certain.</p>
                        <button type="button" className="btn-danger">Delete Account</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>{/* <!-- /Account Section --> */}

  </main>
}

export default function Account(){
    return <Layout>
      <OrdersContextProvider>
          <AccountContent></AccountContent>
      </OrdersContextProvider>

    </Layout>
}